import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TimeZoneService } from 'src/app/modules/shared/services/timezone.service';
import { environment } from 'src/environments/environment';
import { FinanceFilterNS } from '../models/finance-filter.model';
import { HttpService } from 'src/app/modules/shared/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class ReportTableService {

  private userPermissionsBSubject: BehaviorSubject<any>;
  appUrl = "";
  localAppUrl = "";
  coreUrl = ""
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient, private datePipe: DatePipe, private timeZoneService: TimeZoneService, private httpService: HttpService) {
    this.appUrl = environment.apiUrl + "Cases/";
    this.coreUrl = environment.coreUrl;
    this.localAppUrl = environment.localApiUrl;
    this.userPermissionsBSubject = new BehaviorSubject<any>([]);
  }

  openPurchaseOrderReport(data: FinanceFilterNS.FinanceFilterRequestModel) {
    return this.http.post<any>(environment.financeURl + "FinancialReport/GetOpenPurchaseOrderReport?",
      data,
      { observe: 'response' })
      .toPromise()
      .then(res => ({
        inventory: res.body,
        headers: JSON.parse(res.headers.get('x-pagination'))
      }));
  }

  vendorTransactionReport(data: FinanceFilterNS.FinanceFilterRequestModel) {
    return this.http.post<any>(environment.financeURl + "FinancialReport/GetVendorTransactionReport?",
      data,
      { observe: 'response' })
      .toPromise()
      .then(res => ({
        inventory: res.body,
        headers: JSON.parse(res.headers.get('x-pagination'))
      }));
  }

  getVendorTransactionGroupedPagedList(requestModel: FinanceFilterNS.GetAccountsReportGroupByRequestModel){
    return this.httpService.create(`${environment.financeURl}FinancialReport/GetVendorTransactionGroupByReport`, requestModel);
  }

  getOpenPurchaseOrderGroupedPagedList(requestModel: FinanceFilterNS.GetAccountsReportGroupByRequestModel){
    return this.httpService.create(`${environment.financeURl}FinancialReport/GetOpenPurchaseOrderGroupByReport`, requestModel);
  }

}
